import React, { useEffect, useState } from "react";
import { Modal, Form, Input, Spin, InputNumber } from "antd";
import { useDispatch, useSelector } from "react-redux";
import { save } from "../../../../../features/save/saveSlice";
import toast from "react-hot-toast";
import svg150 from "../../../../../assets/svg/svg150.svg";
import svg151 from "../../../../../assets/svg/svg151.svg";
import svg153 from "../../../../../assets/svg/svg153.svg";
import svg154 from "../../../../../assets/svg/svg154.svg";
import Gradient from "../../../../../assets/svg/Gradient.svg";
import BuyTokens from "../BuyTokens";
import AmountToPay from "../AmountToPay";
import PaymentMethod from "../PaymentMethod";
import AccountForm from "../AccountForm";

const ElectricityModal = ({ isModalOpen, handleCancel }) => {
  const [form] = Form.useForm();
  const dispatch = useDispatch();
  const { saving } = useSelector((state) => state.save);
  const [step, setStep] = useState(1);
  const [formData, setFormData] = useState({
    accountNumber: "",
    amount: "",
    requestType: "",
  });

  const handleBuyNow = (data) => {
    setFormData(data);
    setStep(2);
  };

  const handleModalCancel = () => {
    setStep(1);
    setFormData({ accountNumber: "", amount: "", requestType: "" });
    form.resetFields();
    handleCancel();
  };

  const onFinish = async (data) => {
    const res = await dispatch(
      save({ ...data, url: "api/v1/payments/save-payment-category" })
    );
    if (res?.payload?.success) {
      await toast.success(res?.payload?.messages?.message);
      await handleModalCancel();
    } else {
      toast.error(res?.payload?.messages?.message);
    }
  };

  return (
    <Modal
      open={isModalOpen}
      onCancel={handleModalCancel}
      width="30rem"
      footer={null}
      closeIcon={null}
      zIndex={9999}
      className="electricity-modal"
      styles={{
        body: {
          position: "relative",
        },
      }}
    >
      <div
        style={{
          position: "absolute",
          top: 0,
          right: 0,
          bottom: 0,
          left: 0,
          backgroundImage: `url(${Gradient})`,
          backgroundRepeat: "no-repeat",
          backgroundPosition: "top right",
          backgroundSize: "100% auto",
          pointerEvents: "none",
          zIndex: 0,
        }}
      />
      <Form
        layout="vertical"
        form={form}
        onFinish={onFinish}
        style={{ position: "relative", zIndex: 1 }}
      >
        {step === 1 ? (
          <AccountForm
            form={form}
            handleCancel={handleModalCancel}
            handleBuyNow={handleBuyNow}
          />
        ) : (
          <>
            <BuyTokens accountNumber={formData.accountNumber} />
            <AmountToPay amount={formData.amount} form={form} />
            <PaymentMethod
              form={form}
              accountNumber={formData.accountNumber}
              requestType={formData.requestType}
              handleModalCancel={handleModalCancel}
            />
          </>
        )}
      </Form>
    </Modal>
  );
};

export default ElectricityModal;
